import { ActionWatcherService } from '@services/action-watcher.service';

export function ActionWatcherFactory(service: ActionWatcherService): any {
  return () => service.init();
}
